/**
 * @generated SignedSource<<7e3c9513e064f9f13d7bb3bb0b62c193>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RuleCarveOutInputObject = {
  parentRuleId: string;
  perspectiveId?: string | null | undefined;
  stakeholderId?: string | null | undefined;
  stakeholderName?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type ruleDetailPage_CarveOutMutation$variables = {
  input: RuleCarveOutInputObject;
};
export type ruleDetailPage_CarveOutMutation$data = {
  readonly ruleCarveOut: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type ruleDetailPage_CarveOutMutation = {
  response: ruleDetailPage_CarveOutMutation$data;
  variables: ruleDetailPage_CarveOutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ruleDetailPage_CarveOutMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RuleCarveOutMutationPayload",
        "kind": "LinkedField",
        "name": "ruleCarveOut",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ruleDetailPage_CarveOutMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RuleCarveOutMutationPayload",
        "kind": "LinkedField",
        "name": "ruleCarveOut",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b44646e1737d34d26d25800ac418faf2",
    "id": null,
    "metadata": {},
    "name": "ruleDetailPage_CarveOutMutation",
    "operationKind": "mutation",
    "text": "mutation ruleDetailPage_CarveOutMutation(\n  $input: RuleCarveOutInputObject!\n) {\n  ruleCarveOut(input: $input) {\n    rule {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0cd88310335a200c09efbd126b169229";

export default node;
